<template>
  <div class="class-selector-button">
    <ButtonTooltip
      type="is-primary is-light"
      icon-left="users"
      @click="openClassSelectModal"
      :label="displayClassName"
      :tooltip="tooltipText"
    />

    <!-- ClassSelect Modal -->
    <b-modal
      v-model="isModalOpen"
      has-modal-card
      trap-focus
      :destroy-on-hide="false"
      :width="600"
    >
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Select Class</p>
          <button
            type="button"
            class="delete"
            @click="isModalOpen = false"
          ></button>
        </header>
        <ClassSelect 
          :initial-open="true" 
          @close-modal="isModalOpen = false"
        />
      </div>
    </b-modal>
  </div>
</template>

<script>
import ClassSelect from "./ClassSelect.vue";
import { mapGetters } from "vuex";
import ButtonTooltip from "../ui/ButtonTooltip.vue";

export default {
  name: "ClassSelectorButton",

  components: {
    ClassSelect,
    ButtonTooltip,
  },

  data() {
    return {
      isModalOpen: false,
    };
  },

  computed: {
    ...mapGetters({
      currentClass: "getCurrentClass",
    }),

    hasClass() {
      return !!this.currentClass && !!this.currentClass.classId;
    },

    fullClassName() {
      if (!this.hasClass) {
        return "";
      }
      return `${this.currentClass.schoolName}${
        this.currentClass.groupName ? ` | ${this.currentClass.groupName}` : ""
      }`;
    },

    displayClassName() {
      if (!this.hasClass) {
        return "Select Class";
      }

      const fullName = this.fullClassName;
      // Truncate if too long (more than 25 characters)
      if (fullName.length > 25) {
        return fullName.substring(0, 22) + "...";
      }
      return fullName;
    },

    tooltipText() {
      if (!this.hasClass) {
        return "No class selected - Click to select a class";
      }
      return this.fullClassName;
    },
  },

  methods: {
    openClassSelectModal() {
      this.isModalOpen = true;
    },
  },

  watch: {
    // Auto-open modal if no class is selected
    hasClass: {
      immediate: true,
      handler(hasClass) {
        if (!hasClass) {
          this.$nextTick(() => {
            this.isModalOpen = true;
          });
        }
      },
    },
  },
};
</script>

<style scoped>
.class-selector-button {
  display: inline-block;
}
</style>
